<template lang='pug'>
  div
    input.d-none(ref='inputImage' type="file" @change="onDetectFiles($event.target.files[0])")
    a(@click='onSelectImage')
      v-avatar.mb-3(:size='200' color='grey lighten-4')
        v-img(v-if='urlImage' :src='urlImage')
        .title(v-else) Sem Imagem
    .text-center.pt-2(v-if='urlImage')
      v-btn(color='error' @click='onRemove') remover
</template>

<script>
import { storage } from '@/store/firebase'
import fileUtils from '@/utils/file'

export default {
  name: 'upload-file-image',

  props: {
    value: {
      type: String
    },
    storageRef: {
      type: String
    }
  },

  watch: {
    value(val) {
      this.urlImage = val
    }
  },

  data() {
    return {
      file: null,
      urlImage: ''
    }
  },

  methods: {
    onRemove() {
      this.file = null
      this.$refs.inputImage.value = null
      this.$emit('input', null)
    },
    async onDetectFiles(file) {
      this.file = file
      const imgBase64 = await fileUtils.getBase64(file)
      this.$emit('input', imgBase64)
    },
    onSelectImage() {
      this.$refs.inputImage.click()
    },
    onUploadImage() {
      return new Promise((resolve, reject) => {
        if (!this.file) return resolve(null)
        
        // 🔄 MIGRATION FIX: Use storage.ref(path) directly instead of .child()
        const fullPath = `${this.storageRef || ''}/${new Date().getTime()}_${this.file.name}`
        const storageRef = storage.ref(fullPath)
        
        // 🔄 MIGRATION FIX: Handle put() as a Promise (API REST adapter behavior)
        storageRef.put(this.file)
          .then((snapshot) => {
            // Upload success, get URL
            return snapshot.ref.getDownloadURL()
          })
          .then((downloadURL) => {
            resolve(downloadURL)
          })
          .catch((error) => {
            console.error('Upload error:', error)
            reject(error)
          })
      })
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>
